import {useEffect, useState} from 'react';
import axios from 'axios';
import {GET_THIRD_PARTY_COMPONENTS} from '../../../../constants/api.constants';
import {getAppLang, getProperty} from '../../../../utils';

// Ucuncu parti bilesenler (Google Analytics, Tag Manager, Meta Pixel, Google yorumlari…)
// ayri bir ekranda yonetiliyor ve redux'a baglanmamis; ayarlar sayfasi yalnizca
// "kac tanesi aktif" ozetini gostermek icin ayni ucu okur.
export default function useThirdPartyComponents() {
    const [components, setComponents] = useState([]);
    const [fetching, setFetching] = useState(true);

    useEffect(() => {
        let cancelled = false;

        axios.post(
            GET_THIRD_PARTY_COMPONENTS,
            {params: {property_id: getProperty(), channel_id: 1}},
            {
                headers: {
                    Accept: 'application/json',
                    authToken: localStorage.getItem('auth'),
                    'Content-Type': 'application/json',
                    language: getAppLang(),
                },
            }
        ).then((result) => {
            if (cancelled) return;
            setComponents(Array.isArray(result?.data?.data) ? result.data.data : []);
            setFetching(false);
        }).catch(() => {
            if (cancelled) return;
            setComponents([]);
            setFetching(false);
        });

        return () => {
            cancelled = true;
        };
    }, []);

    const active = components.filter((component) => component && component.is_selected);

    // Bilesen anahtari kimi kayitta `component`, kimi kayitta yalnizca `name` uzerinden
    // ayirt edilebiliyor; ikisinde de bosluksuz/kucuk harf karsilastirma yapilir.
    const find = (needle) => components.find((component) => {
        if (!component) return false;
        const key = String(component.component || '').toLowerCase();
        const name = String(component.name || '').toLowerCase().replace(/\s+/g, '');
        return key === needle || name === needle;
    }) || null;

    return {
        components,
        activeComponents: active,
        activeCount: active.length,
        find,
        // Sitede yorum gostermek icin placeId bu bilesende tanimlanir
        googleReview: find('googlereview'),
        // Search Console dogrulama kodu bu bilesenle siteye basiliyor
        googleSiteVerification: find('googlesiteverification'),
        fetching,
    };
}
